import { parseRichText } from './rich-text/parse-rich-text';
import { richTextToPlainText } from './rich-text/rich-text-to-plain-text';

// Only a recognisable tag counts as HTML. A plain-text description containing a stray `<`
// ("5 < 10 and 20 > 15") must come back byte-identical — the save path compares against this
// projection to decide whether the description was touched at all.
const htmlTagRegex = /<\/?[a-z][\w-]*(?:\s[^<>]*)?\/?>/i;

export const htmlToPlainText = (value: string): string => {
  if (!value || !htmlTagRegex.test(value)) {
    return value;
  }
  return richTextToPlainText(parseRichText(value));
};

// "Is this plain text still just a projection of that markup?" — the single question behind
// both "the description was not edited, keep it off the patch" and "the original markup is
// still a truthful rendering, so show its bold and italics". Two copies would let the read
// view show formatting that the save then silently strips.
export const isPlainTextUnchangedFromHtml = (
  plainText: string,
  html: string | null | undefined,
): boolean => plainText === htmlToPlainText(html ?? '');
